import { store } from '@core/Store'
import { setBetSlipNewIsOpen } from '@core/Areas/AppHeader/Store'
import { showLogin as showLoginHelper } from '@core/Areas/Login/helpers'
import { openShareOutgoing } from '@core/Areas/ShareBet/ShareBetOutgoing/helpers/emitter'
import type { BetSlipShare } from '@core/Areas/ShareBet/types'

export const toggleBetSlipDrawer = (isOpen: boolean) => store.dispatch(setBetSlipNewIsOpen(isOpen))

export const showLogin = () => {
  showLoginHelper({
    onLoginSuccessCallback: () => {
      store.dispatch(setBetSlipNewIsOpen(true))
    },
  })
  window.scrollTo({ top: 0, behavior: 'smooth' })
}

export const handleShareBet = (share: BetSlipShare['share']) =>
  openShareOutgoing({ contextType: 'betslip', share })
